import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { RequestEducationsViewDto } from '../dto/educations.dto';

@Injectable()
export class EducationsNestApi {

  private service: string = '';
  private model: string = 'Educations';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public listing(empId: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'listing';
    const params: any = {};
    const urlParams: any = { empId: empId };
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public view(payload: RequestEducationsViewDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'view';
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/educations.api.ts